import React, { useContext, useEffect, useRef, useState } from 'react';
import MaterialTable from 'material-table';
import { tableIcons } from '../../users/TableIcons';
import app from '../../../authentication/firebaseStart';
import { AuthContext } from '../../../authentication/Auth';
import Pagination from '../../users/components/Pagination';
import SiteToolbar from '../../users/components/SiteToolbar';
import styled from "styled-components";
import {
  PageTitle,
} from "../../../styled-components/shared";
import GoBack from '../../../components/GoBack';
import { Tooltip } from '@material-ui/core';
import DropdownActions from '../../../components/DropdownSimple';
import DevicesManageAMDModal from '../../../components/modals/DevicesManageAMDModal';
import CsvCompModal from '../../../components/modals/CsvCompModal';
import { SitesConfigData, SitesConfigDataWithIP } from '../../../components/SitesCsvConfig';

import { AddSiteModal } from '../../../components/modals/AddSiteModal';

import { EditSiteModal } from '../../../components/modals/EditSiteModal';

import Checkbox from '@material-ui/core/Checkbox';
import { SiteService } from '../../../Services/SiteService';
import ActionDropDown from "../../../components/ActionDropDown";

import { useTranslation } from "react-i18next";
import ConfirmationModal from "../../../components/modals/ConfirmationModal";

import { SnackbarContent } from "../../../styled-components/shared";
import { Snackbar } from "@material-ui/core";
import BottomNavLinks from '../../../components/BottomNavLinks';
import { getURLFromGCSBucket } from "../../commonUtils/ExportUtils"
import firebaseUtil from "../../../data/FirebaseUtil";
import AlertModal from '../../../components/modals/AlertModal';
import { convertUtcToTimeZone } from '../../../data/dateTimeUtil';

const CuzCell = styled.p`
  overflow: hidden;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
`;

const BacknTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px; 

`;

const DropDownWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 10px;
    // flex-direction: column;
    label{
      font-weight: 500;
      margin: 0;
      // color: #1386c1;
      font-size: 15px;
    }
`;

const MainContent = styled.div`
  border-top: 2px solid #e1e1e1;
  borer-bottom: none;
  border: 1px solid #bdbdbd;
`;

const PageWrapper = styled.div`
    background: white;
    box-shadow: 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%), 0 1px 3px 0 rgb(0 0 0 / 20%);
    padding: 20px;
`;
var allApsData = [];
var allDevData = [];


const firestore = app.firestore();

const imgStyleLoader = {
  width: 18,
  height: 18,
  marginTop: 6,
  marginLeft: -15,
  marginRight: 5,
}

function SitesDashboard() {
  const context = useContext(AuthContext);
  const DEFAULT_ROWS_PER_PAGE = 10;
  const [pageSize, setPageSize] = useState(DEFAULT_ROWS_PER_PAGE);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [itemCount, setItemCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchText, setSearchText] = useState('');
  const DevicesManageAMDModalRef = useRef();
  const [manageBtnValue, setManageBtnValue] = useState({})
  const CsvCompModalRef = useRef();

  const siteAddRef = useRef();
  const siteUpdateRef = useRef();

  const [sitesData, setSitesData] = useState([])
  const [apsData, setApsData] = useState([])
  const [devicesData, setDevicesData] = useState([])
  const [enableModDelete, setEnableModDelete] = useState(false)
  const [hasUpdatedTime, setHasUpdatedTime] = useState(false)
  const [isLoadingCsv, setIsLoadingCsv] = useState(false)

  const [selectedData, setSelectedData] = useState([]);
  const [selectAll, setselectAll] = useState(false);

  const [_ds, onRowSelected] = useState('')

  const service = new SiteService();

  const companyID = context.currentUser.claims.companyID;

  const [confirmPopupData, setconfirmPopupData] = useState([]);

  const { t } = useTranslation();

  const confirmationModalRef = useRef();

  const [isSnackBarOpen, setIsSnackBarOpen] = useState(false);
  const snackBarContent = useRef();
  const isSnackbarFailure = useRef();
  const alertModalRef = useRef();
  const [errorMessage, setErrorMessage] = useState('');
  const [searchField, setSearchField] = useState('');
  const [searchString, setSearchString] = useState('');

  useEffect(() => {
    getData(pageSize);
    getAppSettings();
  }, []);

  async function getInitialUpdatedTimeData() {
    setIsLoadingCsv(true)
    let companyID = context.currentUser.claims.companyID;
    let data = (
      await firestore
        .collection("tenants")
        .doc(companyID)
        .collection("Configuration")
        .doc("UpdatedTime")
        .get()
    ).data();
    if (data) {
      setHasUpdatedTime(true)
    } else {
      setHasUpdatedTime(false)
    }
    setIsLoadingCsv(false)
  }

  const getSiteSearchData = (searchVal,opt)=>{
    setSearchString(searchVal);
    setSearchField(opt)
  }


  async function getInitialSitesData() {
    setIsLoadingCsv(true)
    let companyID = context.currentUser.claims.companyID;
    let sitesVal = (
      await firestore
        .collection('tenants')
        .doc(companyID)
        .collection('SiteLocations')
        .get()
    ).docs.map((doc) => doc.data());

    if (sitesVal.length > 0) {
      setEnableModDelete(true);
    } else {
      setEnableModDelete(false);
    }
    getInitialUpdatedTimeData();
    setSitesData(sitesVal);
    setIsLoadingCsv(false)
  }

  const onSelectAllChecked = (e) => {
    //Toggle the selection
    //let checked = !selectAll;

    let selectedRowData = [];
    let items = [];


    if (searchText == "") {
      //No filter selcted
      data.forEach(element => {
        //Set selected for each data
        let _data = { ...element, ...{ checked: !selectAll } }
        selectedRowData.push(_data);
        items.push(_data);
      });
    } else {
      //Set isselected only for the current page
      for (let index = 0; index < pageSize; index++) {
        const element = data[(currentPage * pageSize) + index];
        if (element) {

          let _data = { ...element, ...{ checked: !selectAll } }
          selectedRowData.push(_data);
          items.push(_data);
        }
      }
    }
    setSelectedData(selectAll ? [] : selectedRowData);
    setselectAll(!selectAll);
    setData(items);
    onRowSelected(!_ds);
  }

  const getAllData = async (lastReported) => {
    setIsLoadingCsv(true)
    let Query = firestore.collection("tenants")
      .doc(companyID)
      .collection('Devices')
      .orderBy('reportedAt', 'desc')
    if (lastReported != null) { Query = Query.startAfter(lastReported) }
    const snapshot = (await Query.limit(1000).get());
    let snapshotData = snapshot.docs.map((doc) => doc.data());
    allDevData = allDevData.concat(snapshotData)
    setDevicesData(allDevData)
    lastReported = snapshotData[snapshotData.length - 1]?.reportedAt;
    if (snapshotData.length == 0) {
      setIsLoadingCsv(false);
      getAllApsData();
      return
    }
    getAllData(lastReported)
  }

  const getAllApsData = async (lastReported) => {
    setIsLoadingCsv(true)
    let Query = firestore.collection("tenants")
      .doc(companyID)
      .collection('Aps')
      .orderBy('apMacAddress', 'desc')
    if (lastReported != null) { Query = Query.startAfter(lastReported) }
    const snapshot = (await Query.limit(1000).get());
    let snapshotData = snapshot.docs.map((doc) => doc.data());
    allApsData = allApsData.concat(snapshotData)
    setApsData(allApsData)
    lastReported = snapshotData[snapshotData.length - 1]?.apMacAddress;
    if (snapshotData.length == 0) {
      setIsLoadingCsv(false);
      getInitialSitesData();
      return
    }
    getAllApsData(lastReported)
  }

  async function getData(currentPageSize) {
    console.log("came inside get data");
    let itemsPerPage = currentPageSize; /* Should be fetched dynamically from UI */
    let companyID = context.currentUser.claims.companyID;
    setIsLoading(true)
    let totalCount = (
      await firestore.collection('tenants').doc(companyID).collection('SiteLocations').get()
    ).docs.map((doc) => doc.data()).length;
    setItemCount(totalCount);
    setIsLoading(true);

    let aps = [];
    aps = (
      await firestore
        .collection('tenants')
        .doc(companyID)
        .collection('SiteLocations')
        .orderBy('siteName', 'desc')
        .limit(itemsPerPage)
        .get()
    ).docs.map((doc) => doc.data());
    setData(aps);
    setIsLoading(false);
    setCurrentPage(0);
    if (aps.length > 0) {
      setEnableModDelete(true);
    } else {
      setEnableModDelete(false);
    }
  }

  async function next() {
    console.log("came inside next")
    let itemsPerPage = pageSize;
    let startDoc = data[data.length - 1].siteName;
    let companyID = context.currentUser.claims.companyID;
    setIsLoading(true);
    let users = [];
    users = (
      await firestore
        .collection('tenants')
        .doc(companyID)
        .collection('SiteLocations')
        .orderBy('siteName', 'desc')
        .startAfter(startDoc)
        .limit(itemsPerPage)
        .get()
    ).docs.map((doc) => doc.data());
    setIsLoading(false);
    setData(users);
    if (users.length > 0) {
      setEnableModDelete(true);
    } else {
      setEnableModDelete(false);
    }
    setCurrentPage(currentPage + 1);
    clearSelection();
  }

  function getQuery() {
    console.log("came inside get query")
    var searchString = searchText.toUpperCase();
    let query = (firestore
      .collection('tenants')
      .doc(companyID)
      .collection('SiteLocations')
      .orderBy('siteName')
      .startAt(searchString).endAt(searchString + "\uf8ff"));
    return query;
  }

  async function getFilteredRecords() {
    var query = getQuery();
    await service.updateSites(companyID, query, "", null);
  }

  async function prev() {
    console.log("came inside prev")
    let itemsPerPage = pageSize; /* Should be fetched dynamically from UI */
    let startDoc = data[0].siteName; /* First user emailId from the current users list */
    let companyID = context.currentUser.claims.companyID;

    setIsLoading(true);
    let users = [];
    users = (
      await firestore
        .collection('tenants')
        .doc(companyID)
        .collection('SiteLocations')
        .orderBy('siteName', 'desc')
        .endBefore(startDoc)
        .limitToLast(itemsPerPage)
        .get()
    ).docs.map((doc) => doc.data());

    setIsLoading(false);
    setData(users);
    if (users.length > 0) {
      setEnableModDelete(true);
    } else {
      setEnableModDelete(false);
    }
    setCurrentPage(currentPage - 1);
    clearSelection();
  }

  async function searchByMacnFriendlyName(value) {
    console.log("came inside searchByMacnFriendlyName")
    try {
      setIsLoading(true);
      let companyID = context.currentUser.claims.companyID;
      let searchString = value.toUpperCase()
      let user = (await firestore
        .collection("tenants")
        .doc(companyID)
        .collection("SiteLocations")
        .orderBy('siteName')
        .startAt(searchString).endAt(searchString + "\uf8ff").get()
      ).docs.map((doc) => doc.data());

      setData(user);
      if (user.length > 0) {
        setEnableModDelete(true);
      } else {
        setEnableModDelete(false);
      }
      setItemCount(user.length);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      setItemCount(0);
      setData([]);
      setEnableModDelete(false);
    }
  }

  function onChangeManageBtn(buttonValue, buttonName) {
    if (buttonValue === 'MODIFY' || buttonValue === 'DELETE') {
      CsvCompModalRef.current.toggleDialog();

    }
    else {
      DevicesManageAMDModalRef.current.toggleDialog();
    }
    setIsLoading(false);
    setManageBtnValue({ name: buttonName, value: buttonValue, page: 'SITE' })
  }

  function continueBtnClicked(value) {
    if (value.importMethod === "UPLOAD_CSV") {
      //getInitialSitesData();
      CsvCompModalRef.current.toggleDialog();
    }
    if (value.importMethod === "MANUAL") {
      siteAddRef.current.toggleDialog();
    }

  }

  function refreshPageClicked() {
    getData(pageSize);
    setSearchText("");
    setIsLoading(true);
    setSelectedData([]);
  }

  function onCancelHit() {
    allApsData = [];
    allDevData = [];
  }


  function onActionValueChanged(action) {

    if (action.key == "DELETE") {
      //Set the popup confirmation data. Popup will use this data

      let btnData = [
        { scope: 'delete', innerTxt: t('cancel'), proceed: false, class: '' },
        { scope: 'delete', innerTxt: t('confirm'), proceed: true, class: 'confirm' }
      ]

      //Set the data for showing popup
      setconfirmPopupData({
        title: t('delete'),
        btnData: btnData,
        msg: `${t('deviceDetail.message')}`,
        topMsg: `${selectedData.length} Site${selectedData.length == 1 ? '' : 's'} ${t('deviceDetail.selected')}`,
        needcheck: selectAll,
        checktext: t("deleteAllRecordsConfirmMsg")
      });
      confirmationModalRef.current.toggleDialog();
    }
    else if (action.key == "UPDATE_SITE") {
      //Show EDIT modal
      if(selectedData.length>1 && apsData.deviceRegistrationType === 2){
        setErrorMessage('Multiple sites cannot be updated with auto IP assigment enabled.');
        alertModalRef.current.open();
      }else{
        siteUpdateRef.current.toggleDialog();
      }
    }

  }



  function clearSelection() {
    //Cleawr the selected data
    setSelectedData([]);
    data.forEach((row) => row.checked = false);
    setselectAll(false);
  }


  async function deleteSites(deleteAll) {

    //Deelete all the access points
    if (deleteAll) {
      // Delete all the items. If a filter isapplied, should delete only the filtered items
      //Use the current APS query which will dleete  the current selected
      //data based on search text & other parm
      await service.deleteAllSites(companyID, getQuery());
      //Refresh data. Before that clear the selection
      clearSelection();
      getData(pageSize);
    }
    else {
      //Delete only seleted data..
      var itemsToDelete = selectedData;
      await service.deleteSites(companyID, itemsToDelete);
      let siteInSession = sessionStorage.getItem("selectedSite");
      if(siteInSession && siteInSession != "All Devices"){
        let matchedItem = itemsToDelete.filter(item => item.siteName == siteInSession);
        if(matchedItem.length){
          sessionStorage.setItem("selectedSite", "All Devices");
        }
      }

      //await apsService.de(companyID,  itemsToDelete);
      //Refresh data. Before that clear the selection
      clearSelection();
      getData(pageSize);
    }
    if(searchText != '') {
      setSearchText('');
    }

  }

  async function handleConfirmationPopup(e) {

    //Hide the popup first and then proceed with delete
    confirmationModalRef.current.toggleDialog();

    if (e.btnData.scope == 'delete') {
      if (e.btnData.proceed) {
        //Delete action

        setIsLoading(true);

        await deleteSites(e.checkAll);
        setIsLoading(false);

        var msg = (e.checkAll) ? "All Sites deleted" :
          selectedData.length + " Sites deleted";

        showSnackBar(msg, false);
      }

    }
    else if (e.btnData.scope == 'modify') {
      if (e.btnData.proceed) {
        //Update action
        //Set all seected and call the dialog
      }
    }
  }



  async function showSnackBar(content, isFailure) {
    snackBarContent.current = content;
    isSnackbarFailure.current = isFailure;

    setIsSnackBarOpen(true);
  }

  function getBoolDisplayValue(value) {

    return value ? "Yes" : "No";
    
  }

  const [exportBtnState, setexportBtnState] = useState('none')

  async function exportcsv() {
    if(data && data.length > 0) {
      let data = { "entityType": "sites",
      "searchField": searchField,
      "searchText": searchString }
      setexportBtnState('exporting')
      let response = await firebaseUtil.exportConfiguration(data, t);
      if (response?.status) {
        let url = response.msg.filePath;
        let jobId = response.msg.jobId;
        const ref = firestore.collection('tenants').doc(companyID).collection('Jobs').doc(jobId);
        ref.onSnapshot((querySnapshot) => {
          let items = querySnapshot.data();
          if (items.status === 2) {
            async function getURL() {
              setexportBtnState('down')
              let result = await getURLFromGCSBucket(url, companyID, 'sites');
              setexportBtnState('none')
            }
            getURL();
          }
        })
      }
      else {
        setexportBtnState('none');
        showSnackBar(t('error'), true);
      }
    } else {
      setErrorMessage('Export cannot be performed for empty records');
      alertModalRef.current.open();
    }
  }

  const get12hrsFormat = (e) => {

    const getTwoDigit = (e) => {
      return e.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
    }

    if (e) {
      let cronArray = e.split(' ');
      let hr = Number(cronArray[1]);
      let min = Number(cronArray[0]);
      const Hr = getTwoDigit(hr == 0 ? 12 : (hr > 12 ? hr - 12 : hr));
      const Mi = getTwoDigit(min);
      const AM_PM = hr >= 12 ? 'PM' : 'AM';
      return `${Hr}:${Mi} ${AM_PM}`
    }
    return e
  }
  const getAppSettings = async ()=>{
    try{

      const settings = await firestore.collection('tenants').doc(companyID)
      .collection("Configuration")
      .doc("AppSettings")
      .get()
      setApsData(settings.data());
    }catch(err){
      console.log("get app setting error",err);

    }
  }
  const intialColumns = [
    {
      title: (<Checkbox
        // checked={data && data.length != 0 && (data.length == selectedData.length)}
        //05/02: Fix for selection in the last page. Check PageSie/Current ApS data.length
        checked={pageSize && data && data.length != 0 && ((pageSize == selectedData.length) || (data.length == selectedData.length))}
        onChange={(e) => {
          onSelectAllChecked(e);
        }}
        color="primary"
        name="deviceRow" />),
      field: "friendlyName",
      cellStyle: {
        minWidth: 70,
        maxWidth: 70,
      },
      render: rowData => {
        return (
          <Checkbox
            checked={rowData?.checked ? true : false}
            onClick={(e) => {
              console.log("checkbox clicked");
              let selecedData = selectedData;

              const sortedData = selecedData.filter((x) => x.siteName == rowData.siteName)
              //Update selectedData based on the item
              if (sortedData.length != 0) {
                let rowIndex = selecedData.indexOf(sortedData[0])
                selecedData.splice(rowIndex, 1);
                rowData.checked = false;
                setselectAll(false)
              } else {
                rowData.checked = true;
                selecedData.push(rowData);
              }

              setSelectedData(selecedData)
              onRowSelected(!_ds);
              //QA fix: On click menu was nto hiddeen. So commented that
              // e.stopPropagation()
            }}
            value={rowData.checked}
            onChange={(val) => {

            }}
            color="primary"
            name="deviceRow" />

        )
      }
    },
    {
      //10/05: Fix to show the DB sitename in UI
      title: 'Site Name',
      field: 'siteName',
      cellStyle: {
        minWidth: 150,
        maxWidth: 150,
      },
      render: rowData => {
        return (<span>
          {rowData?.displaySiteName?.length > 10 ?
            <Tooltip title={rowData.siteName} arrow placement="bottom-start">
              <CuzCell>{rowData.siteName}</CuzCell>
            </Tooltip>
            :
            <CuzCell>{rowData?.siteName}</CuzCell>
          }
        </span>
        )
      }

    },
    {
      title: t('site.emailReportTime'),
      field: "scheduledReportTime",
      cellStyle: {
        minWidth: 150,
        maxWidth: 150,
      },
      render: rowData => {
        return (<span>{get12hrsFormat(rowData?.scheduledReportTime)}</span>
        )
      }

    },
    {
      title: 'Time Zone',
      field: "timeZone",
      cellStyle: {
        minWidth: 200,
        maxWidth: 200,
      },
    },
    {
      title: t('site.categories'),
      field: "snapshotReportCategories",
      cellStyle: {
        minWidth: 300,
        maxWidth: 300,
      },
      render: rowData => {
        return (<span>
          {rowData?.snapshotReportCategories?.length > 10 ?
            <Tooltip title={rowData.snapshotReportCategories} arrow placement="bottom-start">
              <CuzCell>{rowData.snapshotReportCategories}</CuzCell>
            </Tooltip>
            :
            <CuzCell>{rowData?.snapshotReportCategories}</CuzCell>
          }
        </span>
        )
      }
    },
    {
      title: t('site.csvAttach'),
      field: "attachCSV",
      cellStyle: {
        minWidth: 200,
        maxWidth: 200,
      },
      render: rowData => {

        return (
          <span>
            {getBoolDisplayValue(rowData?.attachCSV)}
          </span>
        )
      }
    },
    {
      title: t('site.emailSubscription'),
      field: "emailSubscribed",
      cellStyle: {
        minWidth: 200,
        maxWidth: 200,
      },
      render: rowData => {

        return (
          <span>
            {getBoolDisplayValue(rowData?.emailSubscribed)}
          </span>
        )
      }
    },
    {
      title: t('site.email_list'),
      field: "emailList",
      cellStyle: {
        minWidth: 300,
        maxWidth: 300,
      },
      render: rowData => {
        return (<span>
          {rowData?.emailList?.length > 10 ?
            <Tooltip title={rowData.emailList} arrow placement="bottom-start">
              <CuzCell>{rowData.emailList}</CuzCell>
            </Tooltip>
            :
            <CuzCell>{rowData?.emailList}</CuzCell>
          }
        </span>
        )
      }
    },
    {
      title: "Last Updated",
      field: "lastUpdatedAt",
      cellStyle: {
        minWidth: 300,
        maxWidth: 300,
      },
      render: rowData => {
        return (
          <span>
           {rowData?.lastUpdatedAt && convertUtcToTimeZone (new Date(rowData?.lastUpdatedAt)?.toUTCString(), rowData?.timeZone)}
          </span>
        )
      }
    },
  ]
  const IPAddressColumns = [{
    title: "Start IP Address",
    field: "startIPAddress",
    cellStyle: {
      minWidth: 300,
      maxWidth: 300,
    },
    render: rowData => {
      return (
        <span>
          {rowData?.startIPAddress}
        </span>
      )
    }
  },
  {
    title: "End IP Address",
    field: "endIPAddress",
    cellStyle: {
      minWidth: 300,
      maxWidth: 300,
    },
    render: rowData => {
      return (
        <span>
          {rowData?.endIPAddress}
        </span>
      )
    }
  }]


  return (
    <PageWrapper style={{ cursor: isLoading ? "wait" : "default", opacity: isLoading ? '0.4' : '1' }}>
      <div style={{
        display: 'flex',
        alignItem: 'center',
        justifyContent: 'space-between'
      }}>
        <BacknTitle>
          <GoBack />
          <PageTitle style={{ marginBottom: '20px' }}>{'Sites'}</PageTitle>
        </BacknTitle>
        <button

          id="download-data"
          style={{
            padding: '10px 20px',
            backgroundColor:
              exportBtnState == 'none' ? '#007ABA' :
                exportBtnState == 'exporting' ? '#ffc107' :
                  exportBtnState == 'down' ? '#8bc34a' : '#007ABA',
            borderRadius: 4,
            fontFamily: "Segoe UI",
            border: '1px solid ',
            position: 'inline',
            color: ' #fff',
            fontWeight: 500,
            fontSize: '15px',
            cursor: exportBtnState == 'none' ? 'pointer' : 'not-allowed',
            height: 'fit-content',
            margin: 'auto 0',
            display: 'flex',
            alignItems: 'center'
          }}
          onClick={exportcsv}
        >
          {exportBtnState != 'none' ?
            <img src={process.env.PUBLIC_URL + '/csv_export.gif'} style={imgStyleLoader} /> : ""}
          {`${exportBtnState == 'none' ? t('exportingData') :
            exportBtnState == 'exporting' ? t('exporting') :
              exportBtnState == 'down' ? t('downloading') : null}`}
        </button>
      </div>


      <DropDownWrapper>
        <DropdownActions
          styleClassName={'manageDropSite'}
          label={t('csvModal.Manage')}
          opts={
            [
              { name: t('csvModal.Add'), value: 'ADD', active: false },
              { name: t('csvModal.Modify'), value: 'MODIFY', active: !enableModDelete },
              { name: t('csvModal.Delete'), value: 'DELETE', active: !enableModDelete }
            ]
          }
          onChangeAction={onChangeManageBtn}
        />

        <div>
          <ActionDropDown

            label={t('action')}
            disable={false}
            selectedRows={selectedData.length}
            options={[
              { label: t('csvModal.ModifyDetails'), key: 'UPDATE_SITE', action: 'd' },
              { label: t('csvModal.Delete'), key: 'DELETE', action: 'd' }
            ]}
            GetChangeAction={onActionValueChanged}
            clrSelectedRows={() => {

              setselectAll(!selectAll);
              clearSelection();
              onRowSelected(!_ds);
            }}
          />
        </div>
      </DropDownWrapper>

      <div>
        <Snackbar
          open={isSnackBarOpen}
          autoHideDuration={5000}
          onClose={() => {
            setIsSnackBarOpen(false);
          }
          }
        >
          <SnackbarContent error={isSnackbarFailure.current ? true : false}>
            {/* {updatedDeviceCount > 0 ? `${updatedDeviceCount} devices updated` : "No devices updated"} */}
            {snackBarContent.current}
          </SnackbarContent>
        </Snackbar>
      </div>


      <MainContent>
        <MaterialTable
          title="Basic Sorting Preview"
          isLoading={isLoading}
          //insert IP columns at last but one column
          columns={apsData.deviceRegistrationType === 2?intialColumns.slice(0,8).concat(IPAddressColumns,intialColumns.slice(-1)):intialColumns}
          data={data}
          options={{
            // actionsColumnIndex: 2,
            paginationType: 'stepped',
            search: true,
            minBodyHeight: '250px',
            maxBodyHeight: '496px',
            sorting: false,
            // selection: true,
            paging: itemCount > pageSize ? true : false,
            pageSize: pageSize,
            cspNonce: window.NONCE_ID
          }}
          icons={tableIcons}
          onChangeRowsPerPage={(val) => {
            setPageSize(val);
            getData(val);
          }}
          components={{
            Pagination: (props) => (
              <Pagination
                {...props}
                itemCount={itemCount}
                currentPage={currentPage}
                onNextClicked={next}
                onPrevClicked={prev}
              />
            ),
            Toolbar: (props) => (
              <SiteToolbar
                titleProp={'All Sites List'}
                inputSearchPlaceholder={t('searchSiteName')}
                searchText={searchText}
                onSearch={(searchVal) => {
                  if (searchVal != '') {
                    setSearchText(searchVal);
                    searchByMacnFriendlyName(searchVal);
                    getSiteSearchData(searchVal,"siteName");
                    clearSelection();
                  }
                }}
                onClear={(searchVal) => {
                  setSearchText('');
                  getData(pageSize);
                  getSiteSearchData("","");
                  clearSelection();
                }}
                onRefreshClick={() => refreshPageClicked()}
              />
            ),

          }}
        />


      </MainContent>
      <BottomNavLinks />

      <AlertModal 
        modalRef={alertModalRef} 
        message={errorMessage} />
        
      <DevicesManageAMDModal
        modalRef={DevicesManageAMDModalRef}
        importType={manageBtnValue}
        onContinue={continueBtnClicked}
        isLoadingCsv={isLoadingCsv}
      />

      <ConfirmationModal
        title={confirmPopupData.title}
        body={confirmPopupData.msg}
        modalRef={confirmationModalRef}
        btnData={confirmPopupData.btnData}
        topMsg={confirmPopupData.topMsg}
        needcheck={confirmPopupData.needcheck}
        checktext={confirmPopupData.checktext}
        id={'ConfirmationModal'}
        fromConfirmationPopup={handleConfirmationPopup}
      />
      <AddSiteModal
        modalRef={siteAddRef}
        data = {data}
        tenantId={companyID}
        appSetting  = {apsData}
        onSiteAdded={async () => {
          //Refreh the page
          await getData(pageSize);
          showSnackBar("Site added successfully");
          if(searchText != '') {
                setSearchText('');
            }
        }
        }
      />

      <EditSiteModal
        modalRef={siteUpdateRef}
        selectedItems={selectedData}
        filterQuery={getQuery}
        showAllSites={selectAll}
        tenantId={companyID}
        appSetting={apsData}
        data = {data}
        onSitesUpdated={async () => {
          //Refreh the page
          var msg = (selectAll) ? "All Sites updated" :
            selectedData.length + " Sites updated";


          await getData(pageSize);
          clearSelection();


          showSnackBar(msg, false);

        }}
      />

      <CsvCompModal
        modalRef={CsvCompModalRef}
        importType={manageBtnValue}
        ConfigData={apsData.deviceRegistrationType === 2 ? SitesConfigDataWithIP:SitesConfigData}
        deviceRegistrationType = {apsData.deviceRegistrationType}
        refreshPage={refreshPageClicked}
        onCancelHit={onCancelHit}
      />
    </PageWrapper>
  )
}

export default SitesDashboard;